module.exports = __webpack_public_path__ + "assets/shinybg-dd1d443d4a2afe4d6e4b0dc0000feca3.png";


//////////////////
// WEBPACK FOOTER
// ./button/libs/mfButtons/images/shinybg.png
// module id = 59
// module chunks = 4